import { ReturnIcon } from 'components/icons'
import classNames from 'helpers/class-names'
import { Dispatch, FC } from 'react'

interface Props {
  className?: string
  onClick: Dispatch<React.MouseEvent>
  disabled?: boolean
}

export const ConfirmInputButton: FC<Props> = ({
  onClick,
  className,
  disabled,
  ...props
}) => {
  return (
    <button
      disabled={disabled}
      className={classNames(
        'm-0 flex w-full rounded-none border-0 bg-transparent px-1 py-0',
        className,
      )}
      onClick={onClick}
      {...props}>
      <span className="w-full text-end text-2xs font-semibold text-gray-300">
        <ReturnIcon className="inline-block size-3" /> Confirm
      </span>
    </button>
  )
}
